import { render, staticRenderFns } from "./mb-segment-name-input.vue?vue&type=template&id=f5544e32&"
import script from "./mb-segment-name-input.vue?vue&type=script&lang=ts&"
export * from "./mb-segment-name-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports